export default __webpack_public_path__ + "static/media/def.4fd8bb56.svg";